// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registra o Service Worker (o arquivo já faz skipWaiting/claim)
serviceWorkerRegistration.unregister();

// Métricas opcionais (Web Vitals)
reportWebVitals();